module.exports = __webpack_public_path__ + "static/media/receipt-line.9deb80ad.svg";